import React, { Fragment } from 'react';
import CSS from 'csstype';

import { Link } from 'react-router-dom';
import Text from '../../text';
import { Color } from '../../../styles/colors';
type Props = {
  items: {
    title: string;
    className: string;
    linksContainerStyle?: CSS.Properties<string | number>;
    links: {
      label: string;
      url: string;
      id: string;
    }[];
  }[];
};

const SectionLinks = ({ items }: Props) => (
  <Fragment>
    {items.map((section) => (
      <div
        key={section.title}
        className={`${section.className} d-sm-flex flex-sm-column mb-sm-24 mb-lg-36`}
        style={{
          color: Color.tertiary100,
        }}
      >
        <Text el="div" type="title4-blinkui" user1stId={`footer-links-${section.title}`}>
          {section.title}
        </Text>
        <div className="mt-sm-16" style={section.linksContainerStyle}>
          {section.links.map((link, index) => (
            <Link
              id={link.id}
              className={`d-sm-block ${index > 0 ? 'mt-sm-16' : ''}`}
              key={link.label}
              to={link.url}
              style={{
                color: Color.tertiary100,
              }}
            >
              <Text type="body3-blinkui" user1stId={`footer-link-${link.id}`}>
                {link.label}
              </Text>
            </Link>
          ))}
        </div>
      </div>
    ))}
  </Fragment>
);

export default SectionLinks;
